import { Stripe } from "stripe";
import { ApiErrorResponse, ICustomerData } from "./types";

export async function createCustomer(data: ICustomerData) {
  return fetch(process.env.REACT_APP_API_URL + "/createCustomer", {
    mode: "cors",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Cache-Control": "no-cache",
    },
    body: JSON.stringify(data),
  })
    .then(async (response) => {
      return (await response.json()) as
        | ApiErrorResponse
        | Stripe.Response<Stripe.Customer>;
    })
    .then((result) => {
      if ((result as ApiErrorResponse).error) {
        // The card had an error when trying to attach it to a customer.
        throw new Error((result as ApiErrorResponse).error.message);
      }
      return result as Stripe.Response<Stripe.Customer>;
    });
}
